export enum AnimationClass {
  Liked="isLiked",
}

type ApplyAnimationArgs = {
  animationClass: string;
  ref: React.RefObject<HTMLDivElement | null>;
}

const DELAY = 100;

export const applyAnimation = ({ animationClass, ref }: ApplyAnimationArgs) => {
  if (ref.current) {
    ref.current.classList.remove(...Object.values(AnimationClass));

    setTimeout(() => {
      ref.current?.classList.add(animationClass);
    }, DELAY);
  }
};
